import {useTranslation} from 'react-i18next'
import usePrefix from '../prefix'

type Kind = 'components' | 'modals' | 'pages' | 'popovers' | 'tabs' | 'docks'

function useCore(mod: string, kind: Kind, name: string) {
  const prefix = `${mod}-${kind}-${name}`

  const {t} = useTranslation()
  const p = usePrefix(prefix)
  const dotPrefixer = usePrefix(prefix, '.')

  function pt(str?: string, options?: {[key: string]: any}) {
    return t(dotPrefixer(str), options)
  }

  return {p, pt, t}
}

export default useCore
